var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserGradientIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 0.667969C6.70757 0.667969 7.38585 0.94892 7.88594 1.44902C8.38604 1.94911 8.66699 2.62739 8.66699 3.33464C8.66699 4.04188 8.38604 4.72016 7.88594 5.22025C7.38585 5.72035 6.70757 6.0013 6.00033 6.0013C5.29308 6.0013 4.6148 5.72035 4.11471 5.22025C3.61461 4.72016 3.33366 4.04188 3.33366 3.33464C3.33366 2.62739 3.61461 1.94911 4.11471 1.44902C4.6148 0.94892 5.29308 0.667969 6.00033 0.667969ZM6.00033 7.33464C8.94699 7.33464 11.3337 8.52797 11.3337 10.0013V11.3346H0.666992V10.0013C0.666992 8.52797 3.05366 7.33464 6.00033 7.33464Z",
    fill: "url(#paint0_linear_2645_51013)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2645_51013",
    x1: 1.02672,
    y1: -3.27408,
    x2: 12.1815,
    y2: -2.92785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC165"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGradientIcon);
export default __webpack_public_path__ + "static/media/user-gradient-icon.bab20d45a97944e2ca7522478bf802f0.svg";
export { ForwardRef as ReactComponent };